import { useEffect, useState } from 'react';
import { BrandCard } from './buds-header';
import { callApi } from '@/lib/api';

interface Props {
  shop: string;
  refreshToken: number;
}

interface CountView {
  count: number;
}

export function RewardsPanel({ shop, refreshToken }: Props) {
  const [view, setView] = useState<CountView | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await callApi<CountView>('/v1/shopify-app/rewards');
        if (!cancelled) setView(data);
      } catch {
        // keep the last known count
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [refreshToken]);

  if (!view) return null;

  return (
    <BrandCard title="Rewards in Buds">
      <div className="flex items-baseline gap-2">
        <span className="text-3xl font-semibold tabular-nums text-buds-dark">
          {view.count}
        </span>
        <span className="text-sm text-buds-dark/70">
          rewards currently configured for {shop}
        </span>
      </div>
    </BrandCard>
  );
}
